import { MD5 } from "./utils.js"
import hmacSHA256 from "crypto-js/hmac-sha256"
import { decryptDes, encryptDes } from "./common"
import { throwErrorMsg } from "../../utils/throwErrorMsg"
import { env } from "@platform/index"
import { callNativeInvoke } from "../../utils/iOSBridge.js"
import { keyboard } from './keyboard.web'

async function getBrowserSN() {
  try {
    const { data } = await callNativeInvoke("get_device_token")
    const { device_token, app_version } = data
    return { device_token, app_version }
  } catch (e) {
    return { device_token: "", app_version: "" }
  }
}

export const device = {
  info() {
    return {}
  },
  restart() {
    window.location.reload()
  },
  exit() {
    window.close()
  },
  hasSubScreen() {
    return false
  },
  scan() {
    throwErrorMsg("device.scan")
  },
  networkPrinter(options: {}): void {
    throwErrorMsg("device.networkPrinter")
  },
  scanWithData({ }) {
    throwErrorMsg("device.scanWithData")
  },
  removeScanWithData() {
    throwErrorMsg("device.removeScanWithData")
  },
  async getSerialNumber() {
    // throwErrorMsg("device.getSerialNumber")
    try {
      const { device_token, app_version } = await getBrowserSN()
      env.softVersion = app_version
      return device_token
    } catch (e) {
      console.error("getSerialNumber Error", e)
      return ""
    }
  },
  print(template: string, data: TemplateData) {
    throwErrorMsg("device.print")
  },
  md5(str = ""): string {
    try {
      if (str == "" || typeof str !== "string")
        throw Error("Parameter must be of string type and cannot be empty.")
      return MD5(str)
    } catch (e) {
      throw Error(e)
    }
  },
  sha256(text = "", key = "") {
    if (
      text == "" ||
      typeof text !== "string" ||
      key == "" ||
      typeof key !== "string"
    )
      throw Error(
        "Parameters 'text' and 'key' must be of type 'string' and cannot be empty."
      )

    return hmacSHA256(text, key)?.toString()
  },
  /**
   * 默认iv加密des
   * @param text
   * @param key
   */
  des(text = "", key = "") {
    if (
      text == "" ||
      typeof text !== "string" ||
      key == "" ||
      typeof key !== "string"
    )
      throw Error(
        "Parameters 'text' and 'key' must be of type 'string' and cannot be empty."
      )
    if (key.length !== 8) throw Error("Parameters 'key' length must be 8 bits.")
    // const reg = new RegExp("^[a-z0-9A-Z]+$");
    // if (!reg.test(key) || key.indexOf("\\") !== -1)
    //   throw Error(
    //     "The parameter 'key' format is wrong! The 'key' must consist of letters or numbers."
    //   );
    return encryptDes(text, key)
  },
  decryptDES(text = "", key = "") {
    if (
      text == "" ||
      typeof text !== "string" ||
      key == "" ||
      typeof key !== "string"
    )
      throw Error(
        "Parameters 'text' and 'key' must be of type 'string' and cannot be empty."
      )
    if (key.length !== 8) throw Error("Parameters 'key' length must be 8 bits.")
    return decryptDes(text, key)
  },
  /**
   * 自定义iv加密des
   * @param text
   * @param key
   * @param iv
   */
  desIV(text: string, key: string, iv: string) {
    if (
      text == "" ||
      typeof text !== "string" ||
      key == "" ||
      typeof key !== "string" ||
      iv == "" ||
      typeof iv !== "string"
    )
      throw Error(
        "Parameters 'text','key' and 'iv' must be of type 'string' and cannot be empty."
      )
    if (key.length !== 8 || iv.length !== 8)
      throw Error("Parameters 'key' and 'iv' length must be 8 bits.")
    return encryptDes(text, key, iv)
  },
  decryptDESIV(text: string, key: string, iv: string) {
    if (
      text == "" ||
      typeof text !== "string" ||
      key == "" ||
      typeof key !== "string" ||
      iv == "" ||
      typeof iv !== "string"
    )
      throw Error(
        "Parameters 'text','key' and 'iv' must be of type 'string' and cannot be empty."
      )
    if (key.length !== 8 || iv.length !== 8)
      throw Error("Parameters 'key' and 'iv' length must be 8 bits.")
    return decryptDes(text, key, iv)
  },
  getService(serviceType = "") {
    throwErrorMsg("device.getService")
  },
  setProperty(
    config: { serviceName: string; serviceType: string; deviceId?: string },
    params: unknown
  ) {
    throwErrorMsg("device.setProperty")
  },
  idleCallback(fn, options) {
    if (typeof fn !== "function") {
      throw Error("idleCallback fn not function")
    }
    requestIdleCallback(fn, options)
  },
  getDevice(deviceId = "") {
    throwErrorMsg("device.getDevice")
  },
  backListener(fn) {
  },
  removeBackListener() {
  },
  registerServiceProperty(fn, config) {
    throwErrorMsg("device.registerServiceProperty")
  },
  bindExt({ brand, model, type, serviceId, packageName, params }) {
    throwErrorMsg("device.bindExt")
  },
  getProperty(
    config: { serviceName: string; serviceType: string; deviceId?: string },
    params: string[]
  ) {
    throwErrorMsg("device.getProperty")
  },
  keyboardRegister(option) {
    keyboard.addListener(option)
  },
  keyboardUnregister() {
    keyboard.clearListener()
  },
  unregisterServiceProperty(config) {
    throwErrorMsg("device.unregisterServiceProperty")
  },
  registerServiceChange(config) {
    throwErrorMsg("device.registerServiceChange")
  },
  unregisterServiceChange(config) {
    throwErrorMsg("device.unregisterServiceChange")
  },
  launchHandler(action: string, data: string) {
    throwErrorMsg("device.launchHandler")
  },
  registerServiceEvent({ deviceId, serviceId, success, fail }) {
    throwErrorMsg("device.registerServiceEvent")
  },
  unregisterServiceEvent({ deviceId, serviceId, fail }) {
    throwErrorMsg("device.unregisterServiceEvent")
  },
  adapterListener(cb) {
    throwErrorMsg("device.adapterListener")
  },
  searchBTDevice(cb) {
    throwErrorMsg("device.searchBTDevice")
  },
  cancelSearchBT(id: any) {
    throwErrorMsg("device.cancelSearchBT")
  },
  keepScreenOn(keepOn: boolean) {
    throwErrorMsg("device.keepScreenOn")
  },
} as DeviceDSL
